import { useState } from "react";

export default function ReferralLink({ position }) {
  const [copied, setCopied] = useState(false);
  const link = `${window.location.origin}/?ref=${position}`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(link);
    } catch {
      /* clipboard unavailable, input remains selectable for manual copy */
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div data-testid="referral-link-block" className="mt-8">
      <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-[#171512]/50">
        invite a friend
      </p>
      <div className="mt-3 flex items-stretch gap-2">
        <input
          data-testid="referral-link-input"
          readOnly
          value={link}
          onFocus={(e) => e.target.select()}
          className="min-w-0 flex-1 rounded-full border-2 border-[#171512]/15 bg-white px-4 py-2.5 font-mono text-xs text-[#171512]/70 outline-none"
        />
        <button
          type="button"
          data-testid="referral-copy-button"
          onClick={copy}
          className="shrink-0 rounded-full bg-[#171512] px-5 py-2.5 font-mono text-[11px] font-medium uppercase tracking-[0.16em] text-[#FDFBF6] transition-colors duration-200 hover:bg-[#F5C7D4] hover:text-[#171512]"
        >
          {copied ? "copied" : "copy"}
        </button>
      </div>
      <p className="mt-2 text-xs text-[#171512]/50">Share your link. Friends who join through it get credited to you.</p>
    </div>
  );
}
